import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonService } from '@shared/services/common.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-book-demo',
  templateUrl: './book-demo.component.html',
  styleUrls: ['./book-demo.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class BookDemoComponent {
  @Output() closeModalClicked = new EventEmitter<any>();

  environment = environment;
  constructor(private cs: CommonService) { }

  ngOnInit() {
    if (this.cs.isBrowser) {
      if (!document.querySelector('script[src*="MeetingsEmbedCode.js"]')) {
        const script = document.createElement('script');
        script.src = environment.MEETING_EMBED_CODE;
        script.type = 'text/javascript';
        document.body.appendChild(script);
      }
    }
  }

  closeHubspot() {
    this.closeModalClicked.emit(true);
  }

  ngOnDestroy() {
    if (this.cs.isBrowser) {
      const container = document.querySelector('.meetings-iframe-container');
      if (container) container.remove();

      const script = document.querySelector('script[src*="MeetingsEmbedCode.js"]');
      if (script) script.remove();
    }
  }
}
